export interface AuthState {
    userID: string | null;
    userData: IUserData | null; // firebase user model
    isAuthenticated: boolean;
    // isAnonymus: boolean;
    isFetching: boolean;
    error?: any;
    isRegistration: boolean | null;
    hasWeakPassword: boolean;
}

export const AUTH_INIT_STATE: AuthState = {
    userID: null,
    userData: null,
    isAuthenticated: false,
    // isAnonymus: false,
    isFetching: false,
    error: null,
    isRegistration: null,
    hasWeakPassword: false,
};

export interface IUserData {
    displayName: string | null;
    email: string | null;
    phoneNumber: string | null;
    photoURL: string | null;
    providerId: string;
    uid: string;
    isAnonymous: boolean;
    lastSignInTime: number;
    creationTime: number;
}

export type ProviderType = 'apple' | 'facebook' | 'google'
export type SupportedWallets = 'abstract';
